module.exports = __webpack_public_path__ + "img/icon-perfil-politico.0234354e.svg";